import React, { useState } from "react";
// mui
import {
  Dialog,
  Button,
  Container,
  Box,
  Grid,
  Typography,
} from "@mui/material";
// react admin
import { useDataProvider, useNotify, useRefresh } from "react-admin";
// loader
import { Loader } from "../../Loader";

const DeleteHourlyBonusWheel = ({ open, onClose, record }) => {
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await dataProvider.delete("HourlyBonusWheel", {
        id: record.id,
        previousData: record,
      });

      if (response) {
        notify("Hourly Bonus Configuration deleted successfully!", {
          type: "success",
        });
        onClose();
        refresh();
        setLoading(false);
      }
    } catch (error) {
      notify(error.message, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose}>
        {loading && <Loader />}
        <Container component="overlay" maxWidth="sm" sx={{ p: 3 }}>
          <Box className="overlayFormBox">
            <Typography variant="h6" sx={{ mb: 2 }}>
              Confirm Deletion
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you sure you want to delete the configuration? This action cannot be
              undone.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    border: "1px solid rgba(255, 239, 153, 0.20)",
                    color: "#FFF",
                    "&:hover": {
                      border: "1px solid #fff",
                      background: "none",
                    },
                  }}
                  onClick={onClose}
                >
                  cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={handleSubmit}
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#FFD700",
                    color: "#000",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "#FFA000",
                    },
                  }}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Dialog>
    </React.Fragment>
  );
};

export default DeleteHourlyBonusWheel;
